import Navigation from './objects/en/Nav';


export default function App(): JSX.Element {
  return (
    <Navigation />
  );
}
